import { render, staticRenderFns } from "./CurrentTime.vue?vue&type=template&id=1a15946e&scoped=true&"
import script from "./CurrentTime.vue?vue&type=script&lang=js&"
export * from "./CurrentTime.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTime.vue?vue&type=style&index=0&id=1a15946e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15946e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
